var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-map ml-4 mr-4" },
    [
      _vm.type === "create"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row py-3 align-items-center" }, [
                _c("div", { staticClass: "col company-h1" }, [
                  _c("button", {
                    staticClass: "btn btn-back",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("companies-info")
                      }
                    }
                  }),
                  _vm._v("\n        Create Company\n      ")
                ]),
                _vm._v(" "),
                _vm.$_can("companies.coverage.store")
                  ? _c("div", { staticClass: "col text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ld-ext-right",
                          class: _vm.loadingButton ? "running" : "",
                          attrs: {
                            type: "button",
                            disabled: _vm.buttonDisabled
                          },
                          on: {
                            click: function($event) {
                              _vm.saveZips(_vm.zips)
                            }
                          }
                        },
                        [
                          _vm._v("\n          Save\n          "),
                          _c("div", { staticClass: "ld ld-ball ld-flip" })
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("companies-steps-menu", { attrs: { type: "create" } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "edit"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row py-3 align-items-center company-header" },
              [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("h2", { staticClass: "company-h1 mr-3" }, [
                      _c("button", {
                        staticClass: "btn btn-back",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.$router.push("/companies")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.company.name) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.company.status
                      ? [
                          _vm.company.status.name === "Active"
                            ? _c("span", { class: "btn-status btn-active" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Inactive"
                            ? _c("span", { class: "btn-status btn-closed" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Setup Incomplete"
                            ? _c(
                                "span",
                                { class: "btn-status btn-ncover info-company" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.company.status.name) +
                                      "\n            "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btn btn-link p-0 tippy-popup tippy-info",
                                      on: {
                                        mouseover: function($event) {
                                          _vm.showTooltipPrefix = true
                                        },
                                        mouseout: function($event) {
                                          _vm.showTooltipPrefix = false
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showTooltipPrefix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "popover tippy-info-popover"
                                        },
                                        [
                                          _vm._v(
                                            "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-8 d-flex align-items-center justify-content-end"
                  },
                  [
                    _vm.$_can("companies.review.request")
                      ? _c("companies-visibility-bar", {
                          attrs: { company: _vm.company },
                          on: {
                            saved: function($event) {
                              _vm.$emit("saved")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right ml-5",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { type: "button", disabled: _vm.buttonDisabled },
                        on: {
                          click: function($event) {
                            _vm.saveZips(_vm.zips)
                          }
                        }
                      },
                      [
                        _vm._v("\n          Save\n          "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("h6", [
            _vm._v("Select the tool and draw the area, submit with Enter")
          ]),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "map-loader" },
                [
                  _c("clip-loader", {
                    staticClass: "clip-loader",
                    attrs: { color: _vm.loaderColor }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "map", attrs: { id: "mapid" } })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("div", { staticClass: "select-wrap mb-3" }, [
              _c("label", [_vm._v("Search")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchZips,
                    expression: "searchZips"
                  }
                ],
                staticClass: "form-control mb-2",
                attrs: { type: "text", placeholder: "Find zip code" },
                domProps: { value: _vm.searchZips },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchZips = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm._l(_vm.filteredZips, function(zip) {
              return _c(
                "button",
                {
                  key: zip.id,
                  staticClass: "btn btn-dark mr-2 mb-2",
                  on: {
                    click: function($event) {
                      _vm.$_can("companies.coverage.destroy") &&
                        _vm.removeZip(zip)
                    }
                  }
                },
                [
                  _vm._v("\n        " + _vm._s(zip) + "\n        "),
                  _c("span", [_vm._v("x")])
                ]
              )
            }),
            _vm._v(" "),
            _c("error-field", { attrs: { errors: _vm.errors, field: "zips" } })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.$_can("companies.coverage.update")
        ? _c("div", { staticClass: "row my-3" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.showImportModal = true
                    }
                  }
                },
                [_vm._v("Import")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showImportModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", [
                        _c("h4", { staticClass: "mb-3" }, [
                          _vm._v("Import multiple ZIP codes:")
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                  _c("h5", [_vm._v("Enter multiple zip codes")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "select-wrap select-wrap-textarea" },
                        [
                          _c("label", [_vm._v("Enter zip codes")]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.bulkZips,
                                expression: "bulkZips"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { rows: "5", placeholder: "" },
                            domProps: { value: _vm.bulkZips },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.bulkZips = $event.target.value
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(
                        "\n            Please use commas to separate zip codes.\n          "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ld-ext-right",
                          class: _vm.loadingButton ? "running" : "",
                          attrs: {
                            type: "button",
                            disabled: _vm.buttonDisabled
                          },
                          on: { click: _vm.saveBulkZips }
                        },
                        [
                          _vm._v("\n              Import\n              "),
                          _c("div", { staticClass: "ld ld-ball ld-flip" })
                        ]
                      )
                    ])
                  ])
                ])
              ]
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13d420e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13d420e5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesMap.vue
// module id = null
// module chunks = 